export function formatInitialValue(value: string | null): string {
    if (value === null) {
        return '';
    }

    return value;
}

export function formatValue(value: string): string | null {
    if (value === '') {
        return null;
    }

    return BigInt(value).toString();
}
